module.exports = __webpack_public_path__ + "static/img/SY.261a7e0a.svg";